import React from "react"
import { PlusOutlined, ImportOutlined, ScheduleOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"
import getConfig from "@components/Config/getConfig"

const LABEL_CREATE = "Create"
const LABEL_IMPORT = "Import"
const LABEL_SCHEDULE = "Schedule"
const isDistributionsEnabled = getConfig("isDistributionsEnabled")


const getHeaderActions = ({
  openCreateModal,
  openImportModal,
  openScheduleModal,
  selectableActions = [],
  isInvalidBankAccount = false,
  isSchedulesLoading = false,
  hasDistributionsAccount = false,
}) => {
  const canCreateTransactions = hasAccess(['transactions-write'])

  if (!canCreateTransactions) {
    return selectableActions
  }

  const isCreateButtonDisabled =
    !hasDistributionsAccount ||
    isInvalidBankAccount

  const isImportButtonDisabled =
    !hasDistributionsAccount ||
    isInvalidBankAccount

  const items = []

  items.push({
    icon: <PlusOutlined />,
    title: LABEL_CREATE,
    action: openCreateModal,
    disabled: isCreateButtonDisabled,
  })

  items.push({
    icon: <ImportOutlined />,
    title: LABEL_IMPORT,
    action: openImportModal,
    disabled: isImportButtonDisabled
  })

  if (isDistributionsEnabled) {
    items.push({
      icon: <ScheduleOutlined />,
      title: LABEL_SCHEDULE,
      action: openScheduleModal,
      disabled: isSchedulesLoading
    })
  }

  return [
    ...selectableActions,
    ...items,
  ]
}

export default getHeaderActions
